import React, { Component } from 'react';
import { getComponentContent } from '../../helpers.js';
const closeIcon = process.env.REACT_APP_IMAGES_ROOT + 'x.svg';

class MainMenu extends Component {

  constructor(){
    super()
    this.state = {
      hideProductLink: false
    }
    this.content = getComponentContent('MainMenu');
  }

  getLink(type) {
    const appEl = document.getElementsByClassName('dermalogica-sound-sleep-cocoon')[0];
    // console.log('this content: ', this.content);
    if(type === 'product'){
      if(this.props.shopUrl){
        return this.props.shopUrl;
      } else {
        let customLink = appEl.dataset.productClickthrough;
        // return customLink && customLink !== 'null' ? customLink : 'https://www.dermalogica.com/sleepcocoon';
        return customLink && customLink !== 'null' ? customLink : this.content.productLink;
      }
    } else {
      let customLink = appEl.dataset.aboutClickthrough;
      // return customLink && customLink !== 'null' ? customLink : 'http://www.dermalogica.com';
      return customLink && customLink !== 'null' ? customLink : this.content.aboutLink;
    }
  }

  render() {

    // const content = getComponentContent('MainMenu');
    // console.log('content: ', content);
    return (

      <div className="ssc__main-menu" style={{minHeight: this.props.appHeight}}>
        <img className="ssc__main-menu__toggle" onClick={this.props.closeMenu} src={closeIcon} alt="close menu" />
        <div className="ssc__main-menu__screen" onClick={this.props.closeMenu}></div>
        <ul>
          <li><a href={this.getLink('about')} target="_blank" rel="noopener noreferrer">{this.content.meetDermalogica}</a></li>
          {this.state.hideProductLink ? <a/> :
            <li><a href={this.getLink('product')} target="_blank" rel="noopener noreferrer">{this.content.soundSleep}</a></li>
          }
          <li><a href="javascript:CookieConsent.renew();CookieDeclaration.SetUserStatusLabel();" target="_blank" rel="noopener noreferrer">manage cookie</a></li>
        </ul>
      </div>

    );

  }

}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu/MainMenu.js